<template>
  <div class="MissionArchiveDetails">
    <v-dialog v-model="visible">
      <box :title="$t('missionDetails')">
        <v-row class="pa-2">
          <v-col cols="6"
            >{{ $t("PageNo") }}:<span class="text-value">{{
              details.PageNo
            }}</span></v-col
          >
          <v-col cols="6"
            >{{ $t("RequestedPersonName") }}:<span class="text-value">{{
              details.PersonName
            }}</span></v-col
          >
          <v-col cols="6"
            >{{ $t("requestType") }}:<span class="text-value">{{
              mission.Name
            }}</span></v-col
          >
          <v-col cols="6"
            >{{ $t("LastChangeDate") }}:<span class="text-value">{{
              details.LastChangeDate
            }}</span></v-col
          >
          <v-col cols="6"
            >{{ $t("cityName") }}:<span class="text-value">{{
              details.CityName
            }}</span></v-col
          >
          <v-col cols="6"
            >{{ $t("missionLocation") }}:<span class="text-value">{{
              details.Location
            }}</span></v-col
          >
          <v-col cols="6"
            >{{ $t("status") }}:<span
              class="text-value"
              v-text="
                mission.StatusType +
                '-' +
                (details.IsTransfer ? 'انتقال داده شده' : 'انتقال داده نشده')
              "
            ></span
          ></v-col>
          <v-col cols="6"
            >{{ $t("ApprovedPerson") }}:<span
              class="text-value"
              v-text="ApprovedPerson"
            ></span
          ></v-col>
          <v-col cols="6">
            {{ $t("description") }}:

            <span class="text-value">
              {{ details.PersonName }}:{{ details.UserDescription }} <br />
              <span>تائید / رد کننده: {{ details.RejectCommand }}</span></span
            ></v-col
          >
        </v-row>

        <v-card class="ma-2">
          <v-data-table
            v-if="rdGridTimesVisible"
            :items="missionHourList"
            :headers="missionHourHeader"
            disable-pagination
            disable-sort
            hide-default-footer
            dense
          />
        </v-card>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small v-if="visibleEdit" @click="edit">{{ $t("edit") }}</v-btn>
          <v-btn small v-if="visibleDelete" @click="deleteItem">{{
            $t("delete")
          }}</v-btn>
        </v-card-actions>

        <archive-detals-flow
          v-if="ShowMissionFlow"
          :pageNo="details.PageNo"
          :pageType="2"
          :year="mission.Year"
        />
        <div v-else class="text-center py-3">
          <span> روند جریان برگه های منتقل شده قابل مشاهده نمی باشد </span>
        </div>
      </box>
    </v-dialog>
  </div>
</template>

<script>
import ArchiveDetalsFlow from "./ArchiveDetalsFlow.vue";
import ResultType from "../../model/ResultType";
import RequestState from "../../model/RequestState";
import TextUtils from "../../utils/TextUtils";
import i18n from "../../i18n";

const initialData = () => {
  return {
    visible: false,
    mission: "",
    details: "",
    visibleEdit: false,
    visibleDelete: false,
    ApprovedPerson: "",
    rdGridTimesVisible: false,
    ShowMissionFlow: true,
    missionHourList: [],
    missionHourHeader: [
      {
        text: i18n.t("date"),
        value: "BeginDate",
      },
      {
        text: i18n.t("DayName"),
        value: "DayName",
      },
      {
        text: i18n.t("BeginTime"),
        value: "beginTime",
      },
      {
        text: i18n.t("EndTime"),
        value: "EndTime",
      },
    ],
  };
};
export default {
  components: { ArchiveDetalsFlow },
  props: {},
  data() {
    return initialData();
  },
  methods: {
    resetData() {
      Object.assign(this.$data, initialData());
    },
    show(mission) {
      this.resetData();
      this.visible = true;
      this.mission = mission;
      this.GetMissionDetailForPerson(this.mission);
    },
    GetMissionDetailForPerson(item) {
      const params = new URLSearchParams();
      params.append("pageNo", TextUtils.convertToEnglishDigits(item.Pageno));
      params.append("dbkind", item.DBKind);
      params.append("year", item.Year);
      //params.append("perno", "");

      this.$store
        .dispatch("GetMissionDetailForPerson", { params })
        .then((result) => {
          if (result.type == "success") {
            if (result.data.length > 0) {
              this.details = result.data[0];
              this.checkActionsVisiblity();
              this.getApprovedPerson();
              this.GetMissionHourForMission(this.details);
            }
          }
        });
    },
    GetMissionHourForMission(item) {
      console.log(item);
      this.missionHourList = [];
      if (item.IsDaily) {
        debugger
        this.rdGridTimesVisible = true;
        var GetMissionHourForMissionParams = {
          pageNo: TextUtils.convertToEnglishDigits(this.mission.Pageno),
          year: this.mission.Year,
          dbKind:this.mission.DBKind,
        };
        this.$store
          .dispatch("GetMissionHourForMission", {
            GetMissionHourForMissionParams,
          })
          .then((result) => {
            console.log(result);
            if (result.type == ResultType.success) {
              debugger;
              this.missionHourList = result.data;
              console.log(this.missionHourList )
            }
          });
      } else {
        this.rdGridTimesVisible = false;
      }
    },
    hide() {
      this.visible = false;
    },
    getApprovedPerson() {
      if (this.details.ApprovedPerson.trim() == "-1") {
        this.ApprovedPerson = this.$t("webkartManager");
      } else if (this.details.ApprovedPerson.trim() == "000") {
        this.ApprovedPerson = this.$t("winkartManager");
      } else {
        let params = new URLSearchParams();
        params.append("perno", this.details.ApprovedPerson.trim());
        this.$store.dispatch("GetPersonFullName", { params }).then((result) => {
          if (result.type === ResultType.success) {
            this.ApprovedPerson = result.data;
          }
        });
      }
      if(this.details.IsTransferransfer != true && this.details.DB == 1){
        // this.externalFlow=false;
        this.ShowMissionFlow=true;
      }
      else{
        // this.externalFlow=true;
        this.ShowMissionFlow=false;

      }
    },
    checkActionsVisiblity() {
      ////console.log(String.fromCharCode(1740));
      ////console.log(String.fromCharCode(1610));
      this.visibleEdit = false;
      this.visibleDelete = false;

      switch (this.mission.Status) {
        case 0: //darkhost avaliyeh
        case 1: //bargasht khordeh
        case 2: //ersal mojadad
        case 4: //rad shodeh
          //btnPrint.Visible = false;
          this.visibleEdit = this.mission.Status != 1;

          if (this.mission.Status == 1) {
            //emkan hazfe darkhoste rad shodeh
            this.visibleDelete =
              this.$store.state.personel.personelDetail.Permission[15].toString() ==
              "1";
          } else {
            this.visibleDelete = true;
          }
          break;
      }
    },
    edit() {
      this.visible = false;
      //console.log(this.mission);
      let details = {
        PageNo: this.mission.Pageno.toString().trim(),
        Year: this.mission.Year,
        DBKind: this.mission.DBKind,
        selectedPerno: this.$store.auth?.auth?.username,
        from: "request-mission-archive",
      };
      this.details["Year"] = this.mission.Year;
      this.$router.push({
        name: "request-mission",
        params: { details: details },
      });
    },
    deleteItem() {
      var params = [
        {
          PageNo: this.details.PageNo.trim(),
          Year: this.mission.Year,
          AdminPerno: this.details.PerNo.trim(),
          RequestState: RequestState.RequestState.Delete,
          ReasonOfAdmin: "",
          Status: "",
        },
      ];
      this.$store
        .dispatch("OprationOnMissionArchive", { params })
        .then((result) => {
          //console.log(result);
          if (result.type === "success") {
            this.$emit("refresh");
            if (result.data && result.data.length > 0) {
              var description = result.data[0].Description;
              this.$refs.snackbar.show("success", description);
            }
          } else {
            this.$refs.snackbar.show("error", result.error);
          }
        });
    },
  },
};
</script>

<style>
</style>